import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import UserMenu from './UserMenu';
import MobileMenu from './MobileMenu';

function Header({
  username,
  onLogout,
  onManageAccounts,
  onManageTags,
  onSwitchUser,
  pageTitle,
  pageSubtitle,
  infoAttentionCount = 0,
}) {
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path) => {
    return currentPath === path;
  };

  return (
    <header className="App-header">
      <div className="header-content">
        <div className="header-main-row">
          <div className="header-left">
            <h1>Optie Portfolio API</h1>
            <p>{pageSubtitle || 'Overview'}</p>
          </div>
          <MobileMenu 
            username={username}
            onLogout={onLogout}
            onManageAccounts={onManageAccounts}
            onManageTags={onManageTags}
            onSwitchUser={onSwitchUser}
          />
          <nav className="header-nav-section main-nav">
            <Link 
              to="/"
              className={isActive('/') ? 'active' : ''}
            >
              Home
            </Link>
            <Link
              to="/equity"
              className={isActive('/equity') ? 'active' : ''}
            >
              Equity
            </Link>
            <Link
              to="/open-positions"
              className={isActive('/open-positions') ? 'active' : ''}
            >
              Open Positions
            </Link>
            <Link
              to="/trades"
              className={isActive('/trades') ? 'active' : ''}
            >
              Trades
            </Link>
            <Link
              to="/tasty"
              className={isActive('/tasty') ? 'active' : ''}
            >
              Tasty
            </Link>
            <Link
              to="/pmcc"
              className={isActive('/pmcc') ? 'active' : ''}
            >
              PMCC
            </Link>
            <div className="nav-dropdown">
              <Link
                to="/tools"
                className={currentPath.startsWith('/tools') ? 'active' : ''}
              >
                Tools
              </Link>
              <div className="nav-dropdown-menu">
                <Link to="/tools?submenu=option-roi">Option ROI</Link>
                <Link to="/tools?submenu=protective-covered-call">Protective Covered Call</Link>
                <Link to="/tools/earnings">Earnings</Link>
              </div>
            </div>
            <Link
              to="/documentation"
              className={isActive('/documentation') ? 'active' : ''}
            >
              Documentation
              {infoAttentionCount > 0 ? (
                <span className="header-doc-badge" title="Informatie: items die aandacht vragen">
                  {infoAttentionCount > 99 ? '99+' : infoAttentionCount}
                </span>
              ) : null}
            </Link>
            <Link 
              to="/todo"
              className={isActive('/todo') ? 'active' : ''}
            >
              Todo
            </Link>
          </nav>
        </div>
        <div className="header-right">
          <UserMenu 
            username={username}
            onLogout={onLogout}
            onManageAccounts={onManageAccounts}
            onManageTags={onManageTags}
            onSwitchUser={onSwitchUser}
          />
        </div>
      </div>
    </header>
  );
}

export default Header;

